import React from "react";
/** Components Import */
import { FormCheck } from "react-bootstrap";

function Radio({
  divClassName = "",
  className = "",
  size = "md",
  vertical = false,
  items = [],
  value,
  onChange = (e) => {},
}) {
  const ChangeCheck = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className={`${divClassName}`}>
      {items.map((item, index) => {
        return (
          <FormCheck
            key={index}
            id={`radio-${item.value}-${item.text}`}
            className={`${className} ${item.className ? item.className : ""}`}
            type="radio"
            name={`radio-${item.value}-${item.text}`}
            style={item.style}
            size={size}
            disabled={item.disabled ? true : false}
            inline={!vertical}
            label={item.text}
            value={item.value}
            checked={item.value == value}
            onChange={ChangeCheck}
          />
        );
      })}
    </div>
  );
}

export default Radio;
